const MOBILE_BREAKPOINT = 768;

/**
 * Sets args to be passed to AC depending on what device we're using
 */
const setWindowWidth = () => {
  if (!window.blubolt) {
    return
  }

  if (window.innerWidth > MOBILE_BREAKPOINT) {
    window.blubolt.device = 'desktop'
  } else if (window.innerWidth <= MOBILE_BREAKPOINT) {
    window.blubolt.device = 'mobile'
  }
}

export default setWindowWidth;